import { Component, Input, OnInit } from '@angular/core';
import { isUndefined } from 'src/app/services/codeUtils';
import { Navigator } from 'src/app/components/menu/navigator';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { first } from 'rxjs/operators';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';

@Component({
  selector: 'app-deposit-threshold',
  templateUrl: './deposit-threshold.component.html',
  styleUrls: ['./deposit-threshold.component.scss'],
})

export class DepositThresholdComponent implements OnInit {

  @Input() status: any;
  @Input() navigateBackPage;
  @Input() amount: any;
  @Input() customerId: any;
  @Input() callBackFn: () => void;
  
  public environmentName: string;
  
  constructor(
    public navigator: Navigator,
    public depositService: DepositService,
    public accountBalanceService: AccountBalanceService,
    public appLinksService: AppLinksService,
    public logoutService: LogoutService,
    public configService: ConfigService 
  ) { }

  ngOnInit() {
    this.environmentName = this.configService.getState();
  }

  public onDepositLimitConfirm() {
      this.depositService.callDepositLimitConfirm(this.customerId).pipe(first()).subscribe(
        (response: any) => {
              if (!isUndefined(response) && !!response.result) {
                  //this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: true, message: '$' + this.amount + " has been added to your account."});
                  if(!!this.callBackFn){
                    this.callBackFn();
                  } else {
                    this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: true, message: '$' + this.amount + " has been added to your account." });
                    //this.navigator.toLobby();
                  }
              } else {
                  this.logoutService.onLogout({reason:'OVER_DEPOSIT'});
              }

              setTimeout(()=>{  this.accountBalanceService.updateBalance(); }, 0)
          }, 
          (error) => {
            this.logoutService.onLogout({reason:'CONFIRM_OVER_DEPOSIT_FAIL'})
        }
      )
  }

  closeModal = () => {
      this.logoutService.onLogout();
  }
}
